import React from "react";
import ReactApexChart from "react-apexcharts";
import "./MerchantDashboard.css";
import { useSelector } from "react-redux";
import { maskValue } from "..";

function PayinChart({ payInStatistic }) {
  const showValues = useSelector((s) => s.userReducer.showValues);

  const successful = payInStatistic?.payinSucessfull || 0;
  const failed = payInStatistic?.payinFailed || 0;
  const pending = payInStatistic?.payinPending || 0;
  const totalTransactions = payInStatistic?.payInTotal || 0;

  const data = [
    {
      id: 1,
      name: "Successful",
      percentValues: (successful / totalTransactions) * 100,
      color: "#00C49F",
      count: successful,
    },
    {
      id: 2,
      name: "Pending",
      percentValues: (pending / totalTransactions) * 100,
      color: "#F7B924",
      count: pending,
    },
    {
      id: 3,
      name: "Failed",
      percentValues: (failed / totalTransactions) * 100,
      color: "#FF8042",
      count: failed,
    },
  ];

  const series = [successful, pending, failed];

  const options = {
    chart: {
      height: 200,
      width: 200,
      type: "pie",
    },
    legend: {
      show: false,
      position: "bottom",
    },
    labels: ["Successful", "Pending", "Failed"],
    colors: ["#00C49F", "#F7B924", "#FF8042"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 200 },
          legend: { show: false },
        },
      },
    ],
  };

  return (
    <div>
      <div className="main-box">
        <div>
          <p className="heading-new">TOTAL DEPOSITS</p>
          <p className="merchant-users-1 sub-heading-new">
            {maskValue(payInStatistic?.payInTotal || 0, showValues)}
          </p>
        </div>

        <div>
          <div className="sucess-rate-1">
            <p>Success Rate:</p>
            <p>
              {totalTransactions === 0
                ? "0"
                : maskValue(((successful / totalTransactions) * 100).toFixed(2), showValues)}
              %
            </p>
          </div>
        </div>
      </div>

      <div className="trans-pie-mer">
        {payInStatistic && (
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="pie"
              height={200}
              width={200}
            />
          </div>
        )}

        <div className="data-rate">
          {data.map((category) => (
            <div key={category.id} className="progress-card-category">
              <p
                className="square-box"
                style={{ backgroundColor: category.color }}
              ></p>
              <p className="category-value">
                {category.name}: {maskValue(category.count, showValues)}
              </p>
            </div>
          ))}
        </div>

        <div id="html-dist"></div>
      </div>
    </div>
  );
}

export default PayinChart;
